import React from 'react';
import Text from './base';

const H3 = props => <Text defaultTag="h3" variant="h3" {...props} />;

export default H3;
